<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h720_dialog abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="方案名称">
                    <el-input
                      v-model="dialogAddEditViewForm.schemeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="方案编号">
                    <el-input
                      v-model="dialogAddEditViewForm.schemeNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="类型">
                      <el-input
                        v-model="dialogAddEditViewForm.sortStr"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="人员名称">
                      <el-input
                        v-model="dialogAddEditViewForm.userName"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="活动日期">
                      <el-input
                        v-model="dialogAddEditViewForm.activityDateStr"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="活动时间段">
                      <el-input
                        v-model="dialogAddEditViewForm.activityTimeStr"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="活动场次">
                      <el-input
                        v-model="dialogAddEditViewForm.fieldTypeStr"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="活动场所">
                      <el-input
                        v-model="dialogAddEditViewForm.storeName"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="是否签到">
                      <el-input
                        v-model="dialogAddEditViewForm.isSignInStr"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="签到时间">
                      <el-input
                        v-model="dialogAddEditViewForm.signInTimeStr"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="签到地点">
                      <el-input
                        v-model="dialogAddEditViewForm.signInAddress"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="是否签退">
                      <el-input
                        v-model="dialogAddEditViewForm.isSignOutStr"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="签退时间">
                      <el-input
                        v-model="dialogAddEditViewForm.signOutTimeStr"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="签退地点">
                      <el-input
                        v-model="dialogAddEditViewForm.signOutAddress"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="签到照片">
                      <show-preview :arr-file-data="signInList" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="签退照片">
                      <show-preview :arr-file-data="signOutList" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 图片预览
import showPreview from '@/components/showPreview'
import { initActivitySignInOutInfoApi } from '@/api/activitySignInOutInfo'
export default {
  components: { showPreview },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      dialogAddEditViewForm: {
      },
      dialogAddEditViewFormRules: {},
      signInList: [],
      signOutList: [],
      baseUrl: ''
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.dialogAddEditViewForm = {}
        this.signInList = []
        this.signOutList = []
        this.initPageData()
      }
    }
  },
  methods: {
    // 加载数据
    initPageData() {
      initActivitySignInOutInfoApi({ id: this.dataId }).then(res => {
        const { data } = res
        this.dialogAddEditViewForm = data
        let signInList = data.signInList
        let signOutList = data.signOutList
        signInList.forEach(item => {
          item.url = this.baseUrl + item.attachmentUrl
        })
        signOutList.forEach(item => {
          item.url = this.baseUrl + item.attachmentUrl
        })
        this.signInList = signInList
        this.signOutList = signOutList
        this.loading = false
      })
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
